export default __webpack_public_path__ + "static/media/330_dummy2016-schauspieler01-de.c44d74ef.png";